import Vue from 'vue'
import Vuex from 'vuex'
import login from './modules/login'
import examine from './modules/examine'
import app from './modules/app'
import v2 from '../v2/vuex/index'
import SlsTracker from '@/v2/utils/sls'

Vue.use(Vuex)

const academicYearList = []

const store = new Vuex.Store({
  modules: {
    login,
    examine,
    app,
    v2
  },

  getters: {
    getAcademicYearList: state => state.academicYearList,
    getGradeList: state => state.gradeList,
    isZujuan: state => {
      return state.platform === 'zujuan'
    }
  },

  state: {
    clientId: sessionStorage.getItem('clientId'),
    platform: YJ_SCHOOL_STORAGE.getItem('platform'),
    bv: YJ_SCHOOL_STORAGE.getItem('bv') ? parseInt(YJ_SCHOOL_STORAGE.getItem('bv')) : 0,
    academicYearList: YJ_SCHOOL_STORAGE.getItem('academicYearList') ? JSON.parse(YJ_SCHOOL_STORAGE.getItem('academicYearList')) : academicYearList,
    gradeList: YJ_SCHOOL_STORAGE.getItem('gradeList') ? JSON.parse(YJ_SCHOOL_STORAGE.getItem('gradeList')) : [],
    backDoor: false, // 开发后门
    cardNumType: 'chinese', // chinese 中文、roman 罗马、arabic 阿拉伯数字
    newVersion: true, // 是否为新版本，默认为新版
    isShowVersionBtn: false, // 是否显示版本更新按钮
  },
  mutations: {
    setBv (state, val) {
      state.bv = val
    },
    setClientId (state, val) {
      state.clientId = val
      sessionStorage.setItem('clientId', val);
    },
    setPlatform (state, val) {
      state.platform = val
      YJ_SCHOOL_STORAGE.setItem('platform', val)
    },
    setAcademicYearList (state, val) {
      state.academicYearList = val
    },
    setGradeList (state, val) {
      state.gradeList = val
    },
    setBackDoor (state, val) {
      state.backDoor = val
    },
    setCardNumType (state, val) {
      state.cardNumType = val
    },
    setNewVersion (state, val) {
      state.newVersion = val
    },
    setShowVersionBtn (state, val) {
      state.isShowVersionBtn = val
    }
  },
  plugins: [
    (store) => {
      Vue.nextTick(initSlsTracker)
      store.subscribe((mutation, state) => {
        if (mutation.type === 'LOGIN_SUCCESS') {
          initSlsTracker()
        }
      })
    }
  ]
})

export default store

function initSlsTracker() {
  SlsTracker.reInit()
}
